import currency from 'currency.js';
import { GameId } from '@bg-shared/enums/GameId';
import { formatToUserCurrency } from '@bg-shared/utils/formatToUserCurrency';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { IBalanceState } from './interfaces';

export const balanceSelectors = {
    getBalance: (gameId: GameId) => (state: Record<GameId | 0, IBalanceState>) => {
        // Balance per gameId used only when isApiSendBalancePerGame is in partner response (PLS) otherwise is kept in 0 index
        const balanceState = state[gameId] || state[0];

        let finalBalance = balanceState?.balance || 0;

        if (partnerSettingsStore.isRealtimeBalanceEnabled) {
            // Exclude negative values for few game windows case
            finalBalance = Math.max(
                currency(finalBalance).subtract(balanceSelectors.getTotalStagedAmount(state)).value,
                0,
            );
        }

        return formatToUserCurrency(finalBalance);
    },

    getTotalStagedAmount: (state: Record<GameId | 0, IBalanceState>) =>
        Object.values(state[0]?.stagedAmounts ?? {}).reduce((total, amount) => total + amount, 0),

    getValue: (gameId: GameId) => (state: Record<GameId | 0, IBalanceState>) =>
        currency(balanceSelectors.getBalance(gameId)(state)).value,
};
